// file upload
$(document).on('change', '.file', function(event) {
//   console.log($(this).parent().siblings('.form_descr'));
  if ($(this).get(0).files.length === 0) {
    console.log('No files selected.');
  } else {
    for (let i = 0; i < $(this).get(0).files.length; i++) {
  
      const files = this.files[i];
      const form = new FormData();
      form.append('image', files);
      $.ajax({
        xhr() {
          const xhr = new window.XMLHttpRequest();
          // Upload progress
          xhr.upload.addEventListener('progress', function(evt) {
  
            if (evt.lengthComputable) {
              // var percentComplete = Math.round((evt.loaded / evt.total)*100);
              // Do something with upload progress
              // $('.percent').text(percentComplete).append('%');
              // console.log(percentComplete+'%');
            }
          }, false);
          // Download progress
          xhr.addEventListener('progress', function(evt) {
            if (evt.lengthComputable) {
              // var percentComplete = Math.round((evt.loaded / evt.total)*100);
              // Do something with download progress
              // $('.percent').text(percentComplete).append('%');
              // console.log(percentComplete);
            }
          }, false);
          return xhr;
        },
        type: 'post',
        url: document.location.href,
        data: form,
        dataType: 'json',
        context: this,
        success(data) {
  
          if (data.err === 0) {
            //   $(this).parent().siblings('.form_descr').html('files uploaded');

            let fileInfo = `
            <div class="fileInfoParent">
                <input class="filePathPhisic" name="`+$(this).attr('name')+`" type="hidden" value="${data.path}"></input>
                <span class="fileInfoText">`+data.filename+`</span>
                <span class="filInfoCloseButton" title="remove">X</span>
            </div>
                `;
            if ($(this).attr('multiple')) {
              $(this).parent().siblings('.box-for-files').append(fileInfo);
            }else{
              $(this).parent().siblings('.box-for-files').html(fileInfo);
            }
                
  
            // console.log(fileInfo);
          } else {
            $(this).siblings('.filePathPhisic').val('');
            $(this).siblings('.fileName').text(data.path);
            // $('.percent').text(data.text);
            // console.log(data);
          }
        },
        beforeSend() {
          $(this).siblings('.ebtn').addClass('disabled loading');
        },
        complete() {
          $(this).siblings('.ebtn').removeClass('disabled loading');
        },
        processData: false,
        contentType: false
      });
  
    }
  }
});



// $(document).on('click','.filInfoCloseButton' ,function() {
//   $(this).parent().remove();
// });


document.addEventListener('click', (e) => {
  if (e.target.classList.contains('filInfoCloseButton')) {
    e.preventDefault();
    
    e.target.closest('.form_relative').querySelector('input.file').value = '';
    e.target.parentNode.remove();
  }
});
